import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { authAPI } from '../api/api';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const [status, setStatus] = useState<'loading' | 'allowed' | 'denied' | 'error'>('loading');

  useEffect(() => {
    let cancelled = false;
    authAPI
      .getMe()
      .then((user) => {
        if (!cancelled) {
          setStatus(user.is_admin ? 'allowed' : 'denied');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setStatus('error');
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div
        className="container"
        style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <div className="spinner" />
      </div>
    );
  }

  if (status === 'denied') {
    return <Navigate to="/home" replace />;
  }

  if (status === 'error') {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
